// JsonLd — renders a schema.org JSON-LD block as a literal <script> tag in the
// JSX tree (not via document.head + useEffect), so it's part of React's normal
// render output and gets captured by react-snap's prerendered DOM snapshot.
export default function JsonLd({ data }) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}
